import UnmatchedInteracWireList from '@src/components/Interac/UnmatchedInteracWireList'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import { useTranslation } from 'react-i18next'

const InteracWireListPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <PageHeader title={t('interacWire.unrecordedTransfers')} breadcrumbs={{ current: t('interacWire.title') }} />
      <PageContainer>
        <UnmatchedInteracWireList />
      </PageContainer>
    </>
  )
}

export default InteracWireListPage
